export const metaTitle = 'A gift you’re sure to love';
export const metaDescription = 'A gift is waiting for you';
